export default {"src":"/_next/static/media/1.3ba02365.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};